"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var supportTypes = [
    'String', 'Number', 'Date',
    'Boolean', 'Array', 'Object',
];
exports.supportTypes = supportTypes;
var supportType = {
    String: String,
    Number: Number,
    Boolean: Boolean,
    Array: Array,
    Date: Date,
    Object: Object,
};
exports.supportType = supportType;
var array_1 = require("./array");
exports.array = array_1.default;
var boolean_1 = require("./boolean");
exports.boolean = boolean_1.default;
var number_1 = require("./number");
exports.number = number_1.default;
var object_1 = require("./object");
exports.object = object_1.default;
var string_1 = require("./string");
exports.string = string_1.default;
var date_1 = require("./date");
exports.date = date_1.default;
var supportTypeValidate = {
    String: string_1.default,
    Number: number_1.default,
    Boolean: boolean_1.default,
    Array: array_1.default,
    Date: date_1.default,
    Object: object_1.default,
};
exports.supportTypeValidate = supportTypeValidate;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/index.js
// module id = 30
// module chunks = 0